import React from "react";
import PropTypes from "prop-types";
import cuid from "cuid";

import Icon from "../Icons";
import Label from "./Label";
import Note from "./Note";
import ValidationError from "./ValidationError";

export const Input = ({
  input,
  label,
  helper,
  meta: { error, touched } = {},
  id = cuid(),
  disabled,
  ...rest
}) => (
  <>
    {label && <Label value={label} target={id} />}

    <div className="relative">
      <input
        id={id}
        {...input}
        {...rest}
        type={(input && input.type) || "text"}
        disabled={disabled}
        className={`appearance-none border rounded w-full py-2 px-4
                  text-grey-darker text-14 ${
                    error && touched ? "border-red" : "border-grey"
                  } ${disabled ? "pl-8" : ""}`}
      />

      {disabled && (
        <div className="absolute top-0 mt-2 ml-2 text-grey-darker-1">
          <Icon name="Lock" />
        </div>
      )}
    </div>

    {helper && <Note value={helper} />}
    {error && touched && <ValidationError value={error} />}
  </>
);

Input.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
};
